import React, { useContext } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { loginContext } from '../../App';

const PrivateRoute = ({ children, ...rest }) => {
  const { loggedIn} = useContext(loginContext);
  const location = useLocation();

  return (
    <Route
      {...rest}
      render={(props) =>
        loggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location.pathname === "/login" ? "/" : location }
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;